import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import naive from 'naive-ui';
import dayjs from 'dayjs';
import 'vue-gifplayer/src/gif.css';

createApp(App)
  .use(naive)
  .use(store)
  .use(router)
  .provide('dayJS', dayjs)
  .mount('#app');
